import React from "react";

/**
 * Owner (2026-10-05, ECN-20611): what happened to an ECN task stays visible for good, also
 * after the work is done again: rejections with their reason, work sent back for rework, a
 * task sent again or reopened by Document Control. The events are the task notes the server tags with a kind
 * (DmsController.TaskEventKind); ordinary notes are left to the Task window.
 */
const KIND = {
    rejected: { icon: "ri-close-circle-line", className: "text-danger" },
    sentBack: { icon: "ri-arrow-go-back-line", style: { color: "var(--ssw-ink-orange, #b45309)" } },
    revision: { icon: "ri-arrow-go-back-line", style: { color: "var(--ssw-ink-orange, #b45309)" } },
    reopened: { icon: "ri-arrow-go-back-line", style: { color: "var(--ssw-ink-orange, #b45309)" } },
    sentAgain: { icon: "ri-user-shared-line", style: { color: "var(--ssw-ink-blue, #1d4ed8)" } },
};

/** Badge colour of an assignment state sent by the server. */
export const TASK_STATE_COLOR = {
    Completed: "success",
    Rejected: "danger",
    Reopened: "warning",
    "Assigned again": "info",
    Assigned: "secondary",
};

export default function TaskHistory({ events, className = "" }) {
    const list = (events || []).filter((e) => e && KIND[e.kind]);
    if (list.length === 0) return null;
    return (
        <div className={`small mt-1 ${className}`} style={{ whiteSpace: "pre-wrap" }}>
            {list.map((e, i) => {
                const k = KIND[e.kind];
                return (
                    <div key={i} className={k.className} style={k.style}>
                        <i className={`${k.icon} me-1`} aria-hidden="true"></i>
                        {e.text}
                        {e.when && <span className="text-muted"> ({new Date(e.when).toLocaleDateString()})</span>}
                    </div>
                );
            })}
        </div>
    );
}
